import styled from "@emotion/styled"
import { Button, Container, Typography } from "@mui/material"
import SectionWrapper from "../../components/section-wrapper/section-wrapper.component"
import CustomImage from "../../components/custom-image/custom-image.component"
import Swiper from "swiper"

export const Section = styled(SectionWrapper)`
  border-radius: 0px 0px 32px 32px;
  background: linear-gradient(90deg, #006e56 0.23%, #00a179 61.82%);
  padding-top: ${({ theme }) => theme.typography.pxToRem(160)};

  ${({ theme }) => theme.breakpoints.down("md")} {
    background: linear-gradient(176deg, #006e56 -7.59%, #00a179 64.29%);
    padding-top: ${({ theme }) => theme.typography.pxToRem(77)};
  }
`

export const Wrapper = styled(Container)``

export const TitleContainer = styled.div`
  display: flex;
  column-gap: 1rem;
  align-items: center;
  justify-content: center;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(80)};

  ${({ theme }) => theme.breakpoints.down("sm")} {
    margin-bottom: ${({ theme }) => theme.typography.pxToRem(47)};
    column-gap: 0.5rem;
    svg {
      width: 143.536px;
      height: 35px;
    }
  }
`

export const Title = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(72)};
  font-style: normal;
  font-weight: 300;
  line-height: normal;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(40)};
    line-height: ${({ theme }) => theme.typography.pxToRem(56)};
  }
`

export const Logo = styled(CustomImage)`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 200px !important;
  .gatsby-image-wrapper {
    min-width: 200px !important;
  }
  ${({ theme }) => theme.breakpoints.down("md")} {
    width: 143.536px !important;
    height: 35px !important;
    img {
      width: 143.536px !important;
      height: 35px !important;
    }
  }
`

export const Icon = styled(CustomImage)`
  max-width: 73px;
`

export const CardContainer = styled.div`
  border-radius: 20px;
  background: rgba(30, 228, 131, 0.15);
  padding: 35px 40px;
  height: 100%;

  &.other-color {
    background: rgba(197, 200, 45, 0.15);
  }
`

export const CardTitle = styled(Typography)`
  margin-top: ${({ theme }) => theme.typography.pxToRem(44)};
  color: ${({ theme }) => theme.palette.primary.light};
  margin-bottom: 1rem;
  font-size: ${({ theme }) => theme.typography.pxToRem(24)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(30)};
  letter-spacing: 0.5px;
  opacity: 0.9;
  max-width: 356px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
    line-height: ${({ theme }) => theme.typography.pxToRem(28)};
    font-weight: 600;
  }
`

export const Description = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  margin-bottom: 1rem;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  opacity: 0.9;
  max-width: 356px;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(17)};
    line-height: ${({ theme }) => theme.typography.pxToRem(22)};
    opacity: 0.8;
  }
`

export const ButtonContainer = styled.div`
  display: flex;
  margin-top: ${({ theme }) => theme.typography.pxToRem(32)};
  column-gap: 1rem;
  ${({ theme }) => theme.breakpoints.up("md")} {
    justify-content: center;
    margin-top: ${({ theme }) => theme.typography.pxToRem(56)};
  }
`

export const BottomTitle = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(44)};
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-top: ${({ theme }) => theme.typography.pxToRem(164)};
  text-align: center;

  ${({ theme }) => theme.breakpoints.down("md")} {
    font-size: ${({ theme }) => theme.typography.pxToRem(32)};
    line-height: ${({ theme }) => theme.typography.pxToRem(44)};
    margin-top: ${({ theme }) => theme.typography.pxToRem(98)};
    font-weight: 500;
    text-align: left;
  }
`

export const OptionButton = styled(Button)`
  border-radius: 34px;
  color: ${({ theme }) => theme.palette.primary.light};
  text-transform: unset;
  font-size: ${({ theme }) => theme.typography.pxToRem(17)};
  font-weight: 500;
  padding: 11px 20px 13px 20px;

  &.selected {
    background: var(--Jungle-Green, #33b494);
  }
`

export const SwiperContainer = styled.div`
  .swiper-scrollbar-drag {
    background: ${({ theme }) => theme.palette.primary.light};
  }
`

export const InfoContainer = styled.div``

export const Name = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  font-style: normal;
  font-weight: 500;
  line-height: ${({ theme }) => theme.typography.pxToRem(32)};
`

export const Position = styled(Typography)`
  color: #fbfbff;
  font-size: ${({ theme }) => theme.typography.pxToRem(16)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(24)};
  opacity: 0.7;
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(28)};
  ${({ theme }) => theme.breakpoints.up("md")} {
    line-height: ${({ theme }) => theme.typography.pxToRem(32)};
  }
`

export const Review = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.light};
  font-size: ${({ theme }) => theme.typography.pxToRem(19)};
  font-style: normal;
  font-weight: 400;
  line-height: ${({ theme }) => theme.typography.pxToRem(28)};
  opacity: 0.9;
  padding-bottom: 3rem;
`

export const ButtonsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ theme }) => theme.breakpoints.down("sm")} {
    flex-wrap: wrap;
    margin-bottom: ${({ theme }) => theme.typography.pxToRem(27)};
    margin-top: ${({ theme }) => theme.typography.pxToRem(62)};
  }
  margin-bottom: ${({ theme }) => theme.typography.pxToRem(50)};
  margin-top: ${({ theme }) => theme.typography.pxToRem(73)};

  .swiper-button-disabled {
    opacity: 0.5;
  }
`

export const LogoContainer = styled.div`
  position: absolute;
  top: 10px;
  left: 10px;

  width: 60px !important;
  height: 60px !important;
`

export const LogoSwiper = styled(CustomImage)`
  width: 60px !important;
  height: 60px !important;

  img {
    width: 100%;
    height: 100%;
    border-radius: 100px;
    object-fit: cover !important;
    overflow: hidden;
  }
`

export const Circle = styled.div`
  position: relative;
  cursor: pointer;
  .autoplay-progress {
    z-index: 10;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    color: ${({ theme }) => theme.palette.primary.light};
  }

  .autoplay-progress svg {
    --progress: 0;
    z-index: 10;
    width: 100%;
    height: 100%;
    stroke-width: 0.8px;
    stroke: ${({ theme }) => theme.palette.primary.light};
    fill: none;
    stroke-dashoffset: calc(125.6 * (1 - var(--progress)));
    stroke-dasharray: 125.6;
    transform: rotate(-90deg);
  }
`

export const LogosWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 0.5rem;
  max-width: 480px;
  overflow: hidden;
  position: relative;
  ${({ theme }) => theme.breakpoints.down("md")} {
    column-gap: 0cap.2rem;
    flex-wrap: wrap;
  }
  ::after {
    position: absolute;
    right: -5px;
    width: 15%;
    height: 100%;
    content: "";
    z-index: 11;
    background: linear-gradient(270deg, #019773 0%, rgba(1, 144, 110, 0) 100%);
  }
`

export const LogosSlider = styled.div`
  /* width: 480px; */
`
